module.exports = __webpack_public_path__ + "static/img/4.993e4ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/zh/4.png
// module id = NBFn
// module chunks = 0